import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Box, Grid } from "@material-ui/core";
import Submit from "../../components/Submit";
import { useTranslation } from "react-i18next";
import PasswordView from "../../views/account/PasswordView";

const validationSchema = Yup.object().shape({
  password: Yup.string().required("Is required"),
  new_password: Yup.string().required("Is required"),
  confirm_password: Yup.string().required("Is required"),
});

const ChangePasswordForm = ({ onSubmit = () => {}, initialValues }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <Box mt={1} boxShadow={2} display="flex" flexDirection="column" p={2}>
            <PasswordView {...props} />
            <Box mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={10}></Grid>
                <Grid item xs={2}>
                  <Submit
                    {...props}
                    title={t("profile.change_password.button")}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default ChangePasswordForm;
